module.exports = __webpack_public_path__ + "media/images/spinner_blue-a292edf9.gif";